export const CONFIG_SESSION = 'CONFIG_SESSION'

export const CREATE_START_SESSION = 'CREATE_START_SESSION'
export const CREATE_START_SESSION_PENDING = 'CREATE_START_SESSION_PENDING'
export const CREATE_START_SESSION_SUCCESS = 'CREATE_START_SESSION_SUCCESS'
export const CREATE_START_SESSION_FAILURE = 'CREATE_START_SESSION_FAILURE'

export const SELECT_FAZENDA = 'SELECT_FAZENDA'
export const SELECT_START_SESSION_PENDING = 'SELECT_START_SESSION_PENDING'
export const SELECT_START_SESSION_SUCCESS = 'SELECT_START_SESSION_SUCCESS'
export const SELECT_START_SESSION_FAILURE = 'SELECT_START_SESSION_FAILURE'

export const SELECT_SAFRA_FAZENDA = 'SELECT_SAFRA_FAZENDA'

export const SELECT_ANO_PECUARIO_FAZENDA = 'SELECT_ANO_PECUARIO_FAZENDA'

export const CREATE_NEW_ACCOUNT_PENDING = 'CREATE_NEW_ACCOUNT_PENDING'
export const CREATE_NEW_ACCOUNT_SUCCESS = 'CREATE_NEW_ACCOUNT_SUCCESS'
export const CREATE_NEW_ACCOUNT_FAILURE = 'CREATE_NEW_ACCOUNT_FAILURE'

export const LIST_SCHEMES = 'LIST_SCHEMES'
export const LIST_SCHEMES_PENDING = 'LIST_SCHEMES_PENDING'
export const LIST_SCHEMES_SUCCESS = 'LIST_SCHEMES_SUCCESS'
export const LIST_SCHEMES_FAILURE = 'LIST_SCHEMES_FAILURE'